import React from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';
import { Add } from '@mui/icons-material';

interface HouseCollectionHeaderProps {
  title: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
  titleVariant?: 'h3' | 'h4' | 'h5' | 'h6';
  descriptionVariant?: 'body1' | 'body2';
  marginBottom?: number;
}

const HouseCollectionHeader: React.FC<HouseCollectionHeaderProps> = ({
  title,
  description,
  actionLabel,
  onAction,
  titleVariant = 'h4',
  descriptionVariant = 'body2',
  marginBottom = 4,
}) => (
  <Box sx={{ mb: marginBottom }}>
    <Stack direction={{ xs: 'column', md: 'row' }} spacing={2} justifyContent="space-between" alignItems={{ md: 'center' }}>
      <Box>
        <Typography variant={titleVariant}>{title}</Typography>
        {description && (
          <Typography variant={descriptionVariant} color="text.secondary" sx={{ mt: 0.75, maxWidth: 680 }}>
            {description}
          </Typography>
        )}
      </Box>
      {actionLabel && onAction && (
        <Button variant="contained" startIcon={<Add />} onClick={onAction}>
          {actionLabel}
        </Button>
      )}
    </Stack>
  </Box>
);

export default HouseCollectionHeader;